module.exports = __webpack_public_path__ + "static/media/logo2.8ba198fc.png";